import { MapGroupId } from "../../types";
import img from "../../mapImages/Woods2D.webp";

const mapData = {
  groupId: MapGroupId.Woods,
  groupName: {
    en: "Woods",
    ru: "Лес ",
  },
  title: {
    en: "Main 2D",
    ru: "Главная 2D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
